import React from "react";
import { Link } from "react-router-dom";
import "./MediaCard.css";

function MediaCard({
  to,
  href,
  image,
  icon,
  iconLabel,
  tagline,
  title,
  description,
  badge,
  flipped,
}) {
  const content = (
    <>
      <div className="media-card__media">
        {image ? (
          <img src={image} alt="" />
        ) : (
          <div className="media-card__placeholder">
            <i className={`fa-solid ${icon}`}></i>
            <span>{iconLabel}</span>
          </div>
        )}
      </div>
      <div className="media-card__body">
        {tagline && <p className="media-card__tagline">{tagline}</p>}
        <h2 className="media-card__title">{title}</h2>
        <p className="media-card__description">{description}</p>
        {badge && <span className="media-card__badge">{badge}</span>}
      </div>
    </>
  );

  const className = `media-card${flipped ? " media-card--flipped" : ""}`;

  if (href) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={className}>
        {content}
      </a>
    );
  }

  return (
    <Link to={to} className={className}>
      {content}
    </Link>
  );
}

export default MediaCard;
